export function validateInternetForm (data) {
    let errors = {};    
    if (!data.title || data.title == '' || data.title == ' ')
        errors.title = 'Title is required';
    
    if (!data.authors || data.authors == '' || data.authors == ' ') 
        errors.authors = 'Authors are required';
    
    if (!data.publisher || data.publisher == '' || data.publisher == ' ')
        errors.publisher = 'Publisher is required';
    
    if (!data.url || data.url == '' || data.url == ' ')
        errors.url = 'URL is required';
    

    if (Object.keys(errors).length > 0) {
        return errors;
    } else {
        return true;
    }
}